import { render, staticRenderFns } from "./MassCampaigsPage.vue?vue&type=template&id=44faf62e&scoped=true&"
import script from "./MassCampaigsPage.vue?vue&type=script&lang=js&"
export * from "./MassCampaigsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44faf62e",
  null
  
)

export default component.exports